export function getFromSessionStorage(key) {
  return sessionStorage.getItem(key);
}

export function addToSessionStorage(key, value) {
  sessionStorage.setItem(key, value);
  return value;
}

export function addItemsToSessionStorage(key, value) {
  const obj = JSON.stringify(value);
  sessionStorage.setItem(key, obj);
  return obj;
}

export function getItemsFromSessionStorage(key) {
  const data = sessionStorage.getItem(key);
  if (!data) return null;
  return JSON.parse(data);
}

export function deleteFromSessionStorage(key) {
  sessionStorage.removeItem(key);
}
